/**
 * Получить публичный VAPID-ключ для подписки на push.
 * GET /api/push/vapid-key → { publicKey: "..." }
 */
export const getVapidKey = async () => {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/push/vapid-key`,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        },
    );
    if (!response.ok) {
        throw new Error(`vapid-key: ${response.status}`);
    }
    const data = await response.json();
    return { publicKey: data?.publicKey ?? '' };
};

/**
 * Подписать устройство на push.
 * POST /api/push/subscribe
 * @param {{ user_id: string, endpoint: string, keys: { p256dh: string, auth: string }, expirationTime: number | null, device_name: string }} payload
 */
export const subscribePush = async (payload) => {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/push/subscribe`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        },
    );
    if (!response.ok) {
        throw new Error(`push subscribe: ${response.status}`);
    }
    return response.json().catch(() => ({}));
};

/**
 * Отписать устройство от push.
 * POST /api/push/unsubscribe
 * @param {{ endpoint: string }} payload
 */
export const unsubscribePush = async (payload) => {
    const response = await window.fetch(
        `${process.env.REACT_APP_API_URL}/api/push/unsubscribe`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        },
    );
    if (!response.ok) {
        throw new Error(`push unsubscribe: ${response.status}`);
    }
    return response.json().catch(() => ({}));
};
